<template>
    <div>
        <div>
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-desciption">Reduce POS terminal memory consumption by closing unused windows</p>
                        <base-checkbox v-model="menus.enablePosOptimization" >Enable Pos Optimization</base-checkbox>
                    </div>
                    <div class="threshold" v-if="menus.enablePosOptimization" >
                        <base-input
                        v-model="menus.optimizationThreshold"
                        type="number"
                        min="80" 
                        max="100" 
                        style="width: 70px; margin-top: 12px; margin-right: 5px;"/>
                        <label for="optimizationThreshold">% Memory Threshold</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

let component_x;
export default {
  computed: {...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'categoriesOptions']),},
  mounted: async function() {

        component_x = this;
        if(this.$attrs.defaultValue != undefined || this.$attrs.defaultValue != null){
            this.menus = this.$attrs.defaultValue
            this.isNewSetting = false
        }
        this.settingCode = this.$attrs.settingCode

  },

  data(){
    return{
        menus: {
            enablePosOptimization: false,
            optimizationThreshold: 80,
        },
    }
  },
  watch: {
    menus: {
        handler: async function(){
            this.enablePosOptimization = this.menus.enablePosOptimization
            this.optimizationThreshold = this.menus.optimizationThreshold
            var configValues = {}
            configValues[this.settingCode] = this.menus
            component_x.$emit("changeValue", configValues)
        },
        deep: true
    }
  },
    
}
</script>

<style scoped>
.text-desciption{
  color:#525f7f;
  font-size: 13px; 
  font-weight: bold;
}
.threshold{
  padding-left: 63px; 
  display: flex; 
  align-items: center; 
  justify-content: flex-start;
}
</style>